import { ALK_EVENT_TYPE } from '../../model/enums';
import { AlkEvent } from '../../framework/events/alk.event';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Component, ChangeDetectionStrategy, ChangeDetectorRef, ElementRef } from '@angular/core';
import { WizEvent, WizEventManager } from '@wizeoo/akm-component-lib';

@Component({
  selector: 'role-delete-renderer',
  template: `<wiz-hgroup height="100%" width="100%" verticalAlign="center" horizontalAlign="center" [wizDisabled]="wizDisabled">
              <wiz-button [wizIcon]="'icon-close'" class="round-button grid-action-btn" (wizClick)="doDelete($event)" height="16px" width="16px"></wiz-button>
            </wiz-hgroup>`,
  styles: [':host {height:100%; width: 100%; max-width: 100%}'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RoleDeleteRenderer implements AgRendererComponent {
  data: any;

  private _wizDisabled: boolean = false;

  private isAdmin: () => boolean;

  constructor(private cdref: ChangeDetectorRef, private elementRef: ElementRef) { }

  public refresh(params: ICellRendererParams): boolean {
    this.data = params.data;
    this._wizDisabled = (params as any).wizDisabled;
    this.isAdmin = (params as any).isAdmin;
    this.cdref.markForCheck();
    return true;
  }

  public agInit(params: ICellRendererParams) {
    this.data = params.data;
    this.isAdmin = (params as any).isAdmin;
    this._wizDisabled = (params as any).wizDisabled;
    this.cdref.markForCheck();
  }

  get wizDisabled(): boolean {
    return (this._wizDisabled !== undefined && this._wizDisabled) || (!!this.isAdmin && this.isAdmin());
  }

  /**
   * emission d'un evenement de suppression
   * @param event wizevent
   */
  public doDelete(event: WizEvent): void {
    WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.DELETE, this.data, this));
  }
}
